module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar', {
    attrs: {
      "title": "Custom Spinner"
    }
  }), _vm._v(" "), _c('scroller', {
    staticStyle: {
      "top": "44px"
    },
    attrs: {
      "on-refresh": _vm.refresh,
      "on-infinite": _vm.infinite,
      "refresh-layer-color": "#4b8bf4",
      "loading-layer-color": "#ec4949"
    }
  }, [_c('svg', {
    staticClass: "spinner",
    staticStyle: {
      "stroke": "#4b8bf4"
    },
    attrs: {
      "viewBox": "0 0 64 64"
    },
    slot: "refresh-spinner"
  }, [_c('g', {
    attrs: {
      "stroke-width": "7",
      "stroke-linecap": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "10",
      "x2": "10",
      "y1": "27.3836",
      "y2": "36.4931"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "y1",
      "dur": "750ms",
      "values": "16;18;28;18;16;16",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "y2",
      "dur": "750ms",
      "values": "48;46;36;44;48;48",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "stroke-opacity",
      "dur": "750ms",
      "values": "1;.4;.5;.8;1;1",
      "repeatCount": "indefinite"
    }
  })]), _c('line', {
    attrs: {
      "x1": "24",
      "x2": "24",
      "y1": "18.6164",
      "y2": "45.3836"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "y1",
      "dur": "750ms",
      "values": "16;16;18;28;18;16",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "y2",
      "dur": "750ms",
      "values": "48;48;46;36;44;48",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "stroke-opacity",
      "dur": "750ms",
      "values": "1;1;.4;.5;.8;1",
      "repeatCount": "indefinite"
    }
  })]), _c('line', {
    attrs: {
      "x1": "38",
      "x2": "38",
      "y1": "16.1233",
      "y2": "47.8767"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "y1",
      "dur": "750ms",
      "values": "18;16;16;18;28;18",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "y2",
      "dur": "750ms",
      "values": "44;48;48;46;36;44",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "stroke-opacity",
      "dur": "750ms",
      "values": ".8;1;1;.4;.5;.8",
      "repeatCount": "indefinite"
    }
  })]), _c('line', {
    attrs: {
      "x1": "52",
      "x2": "52",
      "y1": "16",
      "y2": "48"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "y1",
      "dur": "750ms",
      "values": "28;18;16;16;18;28",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "y2",
      "dur": "750ms",
      "values": "36;44;48;48;46;36",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "stroke-opacity",
      "dur": "750ms",
      "values": ".5;.8;1;1;.4;.5",
      "repeatCount": "indefinite"
    }
  })])])]), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row",
      class: {
        'grey-bg': index % 2 == 0
      }
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  }), _vm._v(" "), _c('svg', {
    staticClass: "spinner",
    staticStyle: {
      "fill": "#ec4949"
    },
    attrs: {
      "viewBox": "0 0 64 64"
    },
    slot: "infinite-spinner"
  }, [_c('g', [_c('circle', {
    attrs: {
      "cx": "16",
      "cy": "32",
      "stroke-width": "0",
      "r": "3"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill-opacity",
      "dur": "750ms",
      "values": ".5;.6;.8;1;.8;.6;.5;.5",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "r",
      "dur": "750ms",
      "values": "3;3;4;5;6;5;4;3",
      "repeatCount": "indefinite"
    }
  })]), _c('circle', {
    attrs: {
      "cx": "32",
      "cy": "32",
      "stroke-width": "0",
      "r": "3.09351"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill-opacity",
      "dur": "750ms",
      "values": ".5;.5;.6;.8;1;.8;.6;.5",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "r",
      "dur": "750ms",
      "values": "4;3;3;4;5;6;5;4",
      "repeatCount": "indefinite"
    }
  })]), _c('circle', {
    attrs: {
      "cx": "48",
      "cy": "32",
      "stroke-width": "0",
      "r": "4.09351"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "fill-opacity",
      "dur": "750ms",
      "values": ".6;.5;.5;.6;.8;1;.8;.6",
      "repeatCount": "indefinite"
    }
  }), _c('animate', {
    attrs: {
      "attributeName": "r",
      "dur": "750ms",
      "values": "5;4;3;3;4;5;6;5",
      "repeatCount": "indefinite"
    }
  })])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90436d4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/CustomSpinner.vue
// module id = 56
// module chunks = 0